<section class="page-title" style="background-image: url(assets/images/breadcom.png);">
  <div class="auto-container">
    <div class="content-box">
      <div class="row">
        <div class="col-6">
          <div class="title">
            <h1> Reset Password</h1>
          </div>
        </div>
        <div class="col-6">
          <ul class="bread-crumb clearfix text-right">
            <li><a routerLink="/">Home</a></li>
            <li> Reset Password</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="main-wrapper" class="oxyy-login-register">
  <div class="container-fluid">
    <div class="row g-0 min-vh-100">
      <!-- Welcome Text
          ========================= -->
      <div class="col-md-6">
        <div class="hero-wrap d-flex align-items-center h-100">
          <div class="hero-mask opacity-8 bg-primary"></div>

          <div class="hero-content w-100 min-vh-100 d-flex flex-column">

            <div class="row g-0 my-auto">
              <div class="col-10 col-lg-9 mx-auto">
                <h1 class="text-11  mb-4"><span>ANMW</span> National Distribution Monitor</h1>
                <p class="text-4  lh-base mb-5">Welcome to the ANMW National Distribution Monitor which provides
                  constantly updated
                  information on national newspaper distribution throughout the UK</p>

                <img src="./assets/images/loginimg.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Welcome Text End -->

      <!-- Login Form
          ========================= -->
      <div class="col-md-6 d-flex">
        <div class="container">
          <div class="row g-0">
            <div class="col-10 col-lg-10 col-xl-9 mx-auto">
              <div class="main_login">
                <h3 class="fw-600 ">Reset Password</h3>
                <p></p>
                <form id="resetpassword" class="mt-4" [formGroup]="form" (ngSubmit)="submitPage()">
                  <div class="mb-2">
                    <label for="newPassword" class="form-label">New Password</label>
                    <input type="password" maxlength="50" class="form-control" formControlName="password"
                      placeholder="********">
                    <div
                      *ngIf="this.form.get('password')?.errors?.['required']  && (form.controls['password'].dirty|| form.controls['password'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Password required.
                    </div>

                    <div
                      *ngIf="this.form.controls['password'].value.length > 0 && this.form.get('password')?.errors?.['strong']  && (form.controls['password'].dirty|| form.controls['password'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Password should have 12 characters length and atleast one number, one
                      lowercase and upper case letter and special characters
                    </div>


                  </div>
                  <div class="mb-2">
                    <label for="confirmPassword" class="form-label">Confirm Password</label>
                    <input type="password" maxlength="50" class="form-control" formControlName="confirmpassword"
                      placeholder="********">
                    <div
                      *ngIf="this.form.get('confirmpassword')?.errors?.['required']  && (form.controls['confirmpassword'].dirty|| form.controls['confirmpassword'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Confirm Password required.
                    </div>

                    <div
                      *ngIf="this.form.controls['confirmpassword'].value != '' && this.form.controls['password'].value != '' && this.form.controls['password'].value != this.form.controls['confirmpassword'].value   && (form.controls['confirmpassword'].dirty|| form.controls['confirmpassword'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Password and Confirm Password should be same.
                    </div>

                  </div>
                  <div class="row">

                    <div class="col-12">

                      <div class="d-grid text-right">
                        <button type="button" (click)="reset()" class="theme-btn style-one">Cancel</button>
                        <button type="submit" class="theme-btn style-two">Update Password</button>
                      </div>
                    </div>
                    <div *ngIf="passwordChanged" class="col-12 mt-3" style="color:green">
                      Password changed successfuly click <a [routerLink]="['/login']">here</a>to login
                    </div>
                  </div>

                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Login Form End -->
    </div>
  </div>
</div>
<app-footer></app-footer>